"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeBufferSource = void 0;

var basesource_js_1 = require("./basesource.js");

var utils_js_1 = require("../utils.js");

var ArrayBufferSource = /*#__PURE__*/function (_basesource_js_1$Base) {
  (0, _inherits2.default)(ArrayBufferSource, _basesource_js_1$Base);

  var _super = _createSuper(ArrayBufferSource);

  function ArrayBufferSource(arrayBuffer) {
    var _this;

    (0, _classCallCheck2.default)(this, ArrayBufferSource);
    _this = _super.call(this);
    _this.arrayBuffer = arrayBuffer;
    return _this;
  }

  (0, _createClass2.default)(ArrayBufferSource, [{
    key: "fetchSlice",
    value: function fetchSlice(slice, signal) {
      if (signal && signal.aborted) {
        throw new utils_js_1.AbortError('Request aborted');
      }

      return this.arrayBuffer.slice(slice.offset, slice.offset + slice.length);
    }
  }]);
  return ArrayBufferSource;
}(basesource_js_1.BaseSource);

function makeBufferSource(arrayBuffer) {
  return new ArrayBufferSource(arrayBuffer);
}

exports.makeBufferSource = makeBufferSource;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFDQTs7SUFFTUEsaUI7Ozs7O0VBQ0osMkJBQVlDLFdBQVosRUFBdUI7SUFBQTs7SUFBQTtJQUNyQjtJQUNBLE1BQUtBLFdBQUwsR0FBbUJBLFdBQW5CO0lBRnFCO0VBR3RCOzs7O1dBRUQsb0JBQVdDLEtBQVgsRUFBa0JDLE1BQWxCLEVBQXdCO01BQ3RCLElBQUlBLE1BQU0sSUFBSUEsTUFBTSxDQUFDQyxPQUFyQixFQUE4QjtRQUM1QixNQUFNLElBQUlDLHFCQUFKLENBQWUsaUJBQWYsQ0FBTjtNQUNEOztNQUNELE9BQU8sS0FBS0osV0FBTCxDQUFpQkMsS0FBakIsQ0FBdUJBLEtBQUssQ0FBQ0ksTUFBN0IsRUFBcUNKLEtBQUssQ0FBQ0ksTUFBTixHQUFlSixLQUFLLENBQUNLLE1BQTFELENBQVA7SUFDRDs7O0VBWDZCQywwQjs7QUFjaEMsU0FBZ0JDLGdCQUFoQixDQUFpQ1IsV0FBakMsRUFBNEM7RUFDMUMsT0FBTyxJQUFJRCxpQkFBSixDQUFzQkMsV0FBdEIsQ0FBUDtBQUNEOztBQUZEUyIsIm5hbWVzIjpbIkFycmF5QnVmZmVyU291cmNlIiwiYXJyYXlCdWZmZXIiLCJzbGljZSIsInNpZ25hbCIsImFib3J0ZWQiLCJ1dGlsc19qc18xIiwib2Zmc2V0IiwibGVuZ3RoIiwiYmFzZXNvdXJjZV9qc18xIiwibWFrZUJ1ZmZlclNvdXJjZSIsImV4cG9ydHMiXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vZGlzdC1tb2R1bGUvc291cmNlL2FycmF5YnVmZmVyLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19